// extracted by css-extract-rspack-plugin
export default {"root":"_3Heu1TBNYMvNnLPh6zO1g8"};